import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { getFundsManagementCompaniesPath, getProductTypeLabel } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { Section } from '../../Section';
import { Carousel } from '../../Carousel';
import { ManagementCompany } from '../../Products';
export var FundGlobalManagementCompanies = function FundGlobalManagementCompanies(_ref) {
  var productType = _ref.productType,
    managementCompanies = _ref.managementCompanies;
  var topGlobalManagementCompanies = managementCompanies.items.filter(function (element) {
    return element.country !== 'ESP' && element.organization && element.organization.id;
  });
  var theme = useTheme();
  var plural = getProductTypeLabel(productType, 'shortPlural', 'lowercase');
  return React.createElement(Section, {
    title: "Top gestoras",
    subtitle: "Gestoras de ".concat(plural, " internacionales que m\xE1s activos gestionan"),
    link: {
      href: getFundsManagementCompaniesPath(theme, productType),
      text: 'Ver todas las gestoras'
    },
    bottomMargin: true
  }, React.createElement(Carousel, {
    breakpoints: [{
      screen: 'miniPhone',
      items: 1.2
    }, {
      screen: 'phone',
      items: 1.2
    }, {
      screen: 'phablet',
      items: 2.2
    }, {
      screen: 'tablet',
      items: 3.2
    }, {
      screen: 'miniDesktop',
      items: 5.2
    }, {
      screen: 'desktop',
      items: 5.2
    }, {
      screen: 'bigScreen',
      items: 5.2
    }]
  }, topGlobalManagementCompanies.map(function (company) {
    return React.createElement(ManagementCompany, {
      variant: "largeCard",
      key: company.id,
      managementCompany: company,
      productType: productType
    });
  })));
};